import { css } from '@emotion/core';
import helperUtils from '../utils/helper.util';

const tableAltColor = theme => `${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'}`;

const borderBottomLine = theme =>
  css`
    border-bottom: 2px solid ${tableAltColor(theme)};
  `;

const offsetStyleRowForType = ({ cybs }, type) =>
  css`
    &:nth-of-type(${type}) {
      background-color: ${cybs?.base?.cybs?.lightGray ?? '#f4f4f4'};
    }
  `;
const headerText = theme =>
  css`
     word-break: break-all;
  `;

const tableWrapper = ({ minWidth }) => theme => css`
  display: table;
  overflow-x: auto;
  width: 100%;
  min-width: ${minWidth};
  border-collapse: collapse;

  &:focus {
    outline: 1px dashed;
    ${theme?.classes?.skin?.outline?.element?.dark?.styles ?? 'outline-color: #222222'};
    outline-offset: -1px;
  }

    .gridRow {
      display: inline-table;
      vertical-align: inherit;
      border-color: inherit;
    }

    tr {
      vertical-align: middle;
      border-color: inherit;
      height: 3rem;
      ${offsetStyleRowForType(theme, 'even')};
    }

    table.vds-datagrid .vds-checkbox-label {
      margin-left: 0 !important;
    }

    .gridRowHeader th, .gridRow td{
      ${
        helperUtils.checkObjectForDataPath(
          theme,
          'classes.structure.padding.space.left.2'
        )
          ? theme.classes.structure.padding.space.left[2]
          : 'padding-left:1.0rem;label:structPadding;'
      };
      ${
        helperUtils.checkObjectForDataPath(
          theme,
          'classes.structure.padding.space.right.2'
        )
          ? theme.classes.structure.padding.space.right[2]
          : 'padding-right:1.0rem;label:structPadding;'
      };
      ${
        helperUtils.checkObjectForDataPath(
          theme,
          'classes.structure.padding.space.top.1'
        )
          ? theme.classes.structure.padding.space.top[1]
          : 'padding-top:0.5rem;label:structPadding;'
      };
       ${
         helperUtils.checkObjectForDataPath(
           theme,
           'classes.structure.padding.space.bottom.1'
         )
           ? theme.classes.structure.padding.space.bottom[1]
           : 'padding-bottom:0.5rem;label:structPadding;'
       };
      vertical-align: middle;
      border-bottom: 2px solid ${tableAltColor(theme)};
      color: ${tableAltColor(theme)};
    }

    .gridRowHeader {
      ${offsetStyleRowForType(theme, 'even')}
      display: table-row;
      vertical-align: middle;
      color: ${tableAltColor(theme)};
    }

  &.sticky thead tr {
    border-bottom: 2px solid transparent;

    td,
    th {
      position: sticky;
      top: 0;
      background: white;
      box-shadow: inset 0px -2px ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
      border-bottom: 0;
      margin-bottom: 2px;
      z-index: 2;
      display: table-cell;
      vertical-align: middle;
    }
  }

    tr th,
    tr td {
      ${helperUtils.checkObjectForDataPath(
        theme,
        'classes.structure.padding.space.left.2'
      )
        ? theme.classes.structure.padding.space.left[2]
        : 'padding-left:1.0rem;label:structPadding;'};
      ${helperUtils.checkObjectForDataPath(
        theme,
        'classes.structure.padding.space.right.2'
      )
        ? theme.classes.structure.padding.space.right[2]
        : 'padding-right:1.0rem;label:structPadding;'};
      ${helperUtils.checkObjectForDataPath(
        theme,
        'classes.structure.padding.space.top.1'
      )
        ? theme.classes.structure.padding.space.top[1]
        : 'padding-top:0.5rem;label:structPadding;'};
      ${helperUtils.checkObjectForDataPath(
        theme,
        'classes.structure.padding.space.bottom.1'
      )
        ? theme.classes.structure.padding.space.bottom[1]
        : 'padding-bottom:0.5rem;label:structPadding;'};
      vertical-align: middle;
      color: ${tableAltColor(theme)};
    }

    input {
      outline: none;
      border: 0;
    }

    input[type='text']::-ms-clear {
      display: none;
    }

    *:focus,
    input:focus {
      outline: 1px dashed
        ${helperUtils.checkObjectForDataPath(
          theme,
          'variables.colors.element.dark'
        )
          ? theme.variables.colors.element.dark
          : 'rgba(42,46,105,1)'};
    }

    input[type='text']:focus {
      outline: 0 !important;
    }
`;

const footerStyles = theme => ({
  leftContainer: css`
    flex: 1;
    @media (max-width: 320px) {
      margin-top: 0.25rem;
    }
  `,
  leftButtonContainer: css`
    @media (max-width: 320px) {
      width: 100%;
    }
  `,
});

export default {
  tableWrapper,
  offsetStyleRowForType,
  borderBottomLine,
  tableAltColor,
  footerStyles,
  headerText
};
